import React from 'react';

function Science() {
  return (
    <section id="science" className="section science-section">
      <div className="section-heading">
        <p className="eyebrow">01 / Наука</p>
        <h2>Практика, выросшая из исследования</h2>
      </div>
      <div className="science-grid">
        <article className="science-block">
          <span className="block-tag">Кандидатская диссертация</span>
          <h3>Геоинформационное моделирование</h3>
          <p>
            Применение искусственного интеллекта для управления
            территориальными системами Воронежской области.
          </p>
          <a
            className="talk-link"
            href="https://scholar.google.com/citations?user=wzeYZggAAAAJ&hl=ru"
            target="_blank"
            rel="noopener noreferrer"
          >
            Публикации в Google Scholar
          </a>
        </article>
        <article className="science-block">
          <span className="block-tag">Докторская — исследовательская программа</span>
          <h3>Методологические и технологические подходы к управлению социальными системами</h3>
          <p>
            Научные исследования на стыке теории управления, кибернетики,
            искусственного интеллекта, психологии управления и социологии.
          </p>
        </article>
        <article className="science-block">
          <span className="block-tag">MBA</span>
          <h3>Цифровая трансформация</h3>
          <p>
            Теоретико-игровой подход к изменениям в компании и управлению
            стимулами: как перестраивать системы, не ломая людей.
          </p>
        </article>
      </div>
      <div className="science-extra">
        <span className="block-tag">Дополнительное образование — психология</span>
        <p>
          Терапия Души&ensp;·&ensp;Телесно-эмоциональное
          обновление&ensp;·&ensp;Психология архетипов
        </p>
      </div>
    </section>
  );
}

export default Science;
